import antdEn from 'antd/lib/locale-provider/en_US';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';

import enMessages from '../locales/en_US.json';

const enLang = {
  messages: {
    ...enMessages,
  },
  antd: antdEn,
  locale: 'en-US',
};
export default enLang;
